import { Paper, Stack, styled, Typography } from "@mui/material";
import { InternalButtonLink } from "../../InternalButtonLink";

export const ConfirmOverlayPaper = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        p: theme.spacing(6),
        borderRadius: "8px",
        width: "480px",
        maxWidth: "100%",
        margin: "0 auto",
        textAlign: "center",
    }),
);

export const ConfirmOverlayStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "flex-end",
        gap: theme.spacing(4),
    }),
);

export const ConfirmOverlayButton = styled(InternalButtonLink)(({ theme }) =>
    theme.unstable_sx({
        width: { xs: "100%", md: "auto" },
        whiteSpace: "nowrap",
    }),
);

export const ConfirmOverlayText = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(5),
    }),
);
